import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import overlayState from '@/app/shared/infrastructure/state/overlay';

export default /*#__PURE__*/_defineComponent({
  __name: 'Overlay',
  setup(__props) {

const state = overlayState();

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createBlock(_component_v_overlay, {
    "model-value": _unref(state).open,
    style: {"background-color":"rgba(0, 0, 0, 0.5)"},
    class: "align-center justify-center",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_progress_circular, {
        indeterminate: "",
        size: "64",
        width: 11,
        color: "primary"
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})